import { PageBreadcrumbItem } from "components/common/PageBreadcrumb";

export const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const monthsShort = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export const days = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

export const defaultBreadcrumbItems: PageBreadcrumbItem[] = [
  {
    label: "Page 1",
    url: "#!",
  },
  {
    label: "Page 2",
    url: "#!",
  },
  {
    label: "Default",
    active: true,
  },
];

export const reportsBreadcrumbItems: PageBreadcrumbItem[] = [
  {
    label: "Reports",
    url: "/reports",
  },
];

export const reportDetailsBreadcrumbItems: PageBreadcrumbItem[] = [
  {
    label: "Reports",
    url: "/reports",
  },
  {
    label: "Report details",
    url: "/report-details",
  },
];

export const dealDetailsBreadcrumbItems: PageBreadcrumbItem[] = [
  {
    label: "Deals",
    url: "/deals",
    active: false,
  },
  {
    label: "Deal details",
    url: "#",
    active: true,
  },
];

export const dealsBreadcrumbItems: PageBreadcrumbItem[] = [
  {
    label: "Deals",
    url: "/",
  },
];

export const collaboratorBreadcrumbItems: PageBreadcrumbItem[] = [
  {
    label: "Collaborators",
    url: "/collaborators",
  },
];

export const analyticsBreadcrumbItems: PageBreadcrumbItem[] = [
  {
    label: "Analytics",
    url: "/",
  },
];

export const addContactBreadcrumbItems: PageBreadcrumbItem[] = [
  {
    label: "Add lead",
    url: "/add-lead",
  },
];

export const onboardingBreadcrumbItems: PageBreadcrumbItem[] = [
  {
    label: "Information setting",
    url: "/settings/onboarding",
  },
];

export const settingsBreadcrumbItems: PageBreadcrumbItem[] = [
  {
    label: "Profile settings",
    url: "/settings/profile-settings",
  },
];

export const addDealBreadcrumbItems: PageBreadcrumbItem[] = [
  {
    label: "Add deal",
    url: "add-deal",
  },
];

export const updateLeadBreadcrumbItems: PageBreadcrumbItem[] = [
  {
    label: "Leads",
    url: "/leads",
    active: false,
  },
  {
    label: "Update lead",
    // url: "edit-deal",
  },
];

export const leadBreadcrumbItems: PageBreadcrumbItem[] = [
  {
    label: "Leads",
    url: "/leads",
  },
];

export const leadDetailsBreadcrumbItems: PageBreadcrumbItem[] = [
  {
    label: "Leads",
    url: "/leads",
    active: false,
  },
  {
    label: "Lead details",
    url: "#",
    active: true,
  },
];

export const ecomBreadcrumbItems: PageBreadcrumbItem[] = [
  {
    label: "Fashion",
    url: "#!",
  },
  {
    label: "Womens Fashion",
    url: "#!",
  },
  {
    label: "Footwear",
    url: "#!",
  },
  {
    label: "Hills",
    active: true,
  },
];

export const LeadTypeCategories = [
  {
    type: "Buyer",
    stages: [
      "New Lead",
      "Initial Consultation",
      "Pre-Qualification",
      "Active Buyer",
      "Under Contract",
      "Closed",
      "On Hold",
      "Not Interested",
      "Not Ready",
      "Cancelled",
    ],
  },
  {
    type: "Seller",
    stages: [
      "New Lead",
      "CMA Appointment",
      "Listing Appointment",
      "Listed",
      "Under Contract",
      "Closed",
      "On Hold",
      "Not Interested",
      "Not Ready",
      "Back on Market",
    ],
  },
  {
    type: "Renter",
    stages: [
      "New Lead",
      "Property Search",
      "Application",
      "Approved",
      "Lease Signed",
      "On Hold",
      "Not Interested",
    ],
  },
  {
    type: "Investor",
    stages: [
      "New Lead",
      "Strategy Session",
      "Property Analysis",
      "Under Contract",
      "Closed",
      "Portfolio Review",
      "On Hold",
      "Not Interested",
    ],
  },
  {
    type: "Real Estate Agent",
    stages: ["New Contact", "Active Partner", "Referral Partner", "Inactive"],
  },
  {
    type: "Lender",
    stages: ["New Contact", "Active Partner", "Referral Partner", "Inactive"],
  },
  {
    type: "Title / Escrow",
    stages: ["New Contact", "Active Partner", "Referral Partner", "Inactive"],
  },
  {
    type: "Sphere of Influence",
    stages: ["New Contact", "Active Contact", "Referral Source", "Inactive"],
  },
  {
    type: "Vendor Partner",
    stages: ["New Contact", "Active Partner", "Preferred Partner", "Inactive"],
  },
  {
    type: "Other",
    stages: ["New Contact", "Active Contact", "Inactive"],
  },
];

export const collaboratorRole = [
  "Test Role One",
  "Test Role Two",
  "Test Role Three",
  "Test Role Four",
];

export const propertyType = ["Residential", "Commercial", "Multi Family"];
